'use strict';

module.exports = /^(.+?)(\[.*\])$/;